module.exports = "<div class=row> <div class=\"col s12\"> <h4 class=header>Props</h4> <table class=highlight> <thead> <tr> <th>Name</th> <th>Type</th> <th>Default</th> <th>Description</th> </tr> </thead> <tbody> <tr v-for=\"property in data\"> <td>{{property.name}}</td> <td>{{property.type}}</td> <td>{{property.default}}</td> <td>{{property.description}}</td> </tr> </tbody> </table> </div> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ../~/vue-html-loader!../~/vue-loader/lib/selector.js?type=template&index=0!../src/components/properties.vue
 ** module id = 375
 ** module chunks = 0
 **/